<template>
    <el-button type="primary" icon="el-icon-search" @click="clickSearch()"> {{$t('m.search')}} </el-button>
</template>
<script>
export default {
    props:['searchParam'],
    data() {
        return {

        }
    },
    methods: {
        clickSearch() {
            this.searchParam.pageNum = 1
            this.$emit('successMethod')
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/common/LapSearchBtn.vue